/** How both rubrics ask for text a tenant reads: in the language of the agent's instructions, shown under `heading`. */
export function inLanguageOf(heading: string): string {
  return `Written in the language of the text under "${heading}", or in English when there is none.`
}
